// IT
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "Nuovo check-in",
    manualDispatchTitle: "Chiusura manuale dell'invio finale",
    manualDispatchText:
      "Se uno degli ospiti non viaggerà, puoi chiudere manualmente questo processo per inviare ora il messaggio di benvenuto, le chiavi digitali e il documento al responsabile della prenotazione.",
    sending: "Invio in corso...",
    completeManualSend: "Completa manualmente e invia",
    finalSendProcessed: "Invio finale già elaborato",
    arrivalInstructions: "Istruzioni di arrivo",
    arrivalAlreadySent: "Già inviate. Puoi reinviarle all'ospite ora se necessario.",
    arrivalAutoInfo:
      "Vengono inviate automaticamente all'orario previsto. Puoi anticiparle e inviarle ora (messaggio, accessi e file configurati).",
    resendNow: "Reinvia ora",
    sendNow: "Invia ora",

    titleEditCheckin: "Modifica check-in",
    titleDeleteCheckin: "Elimina check-in",

    confirmManualTitle: "Completare l'invio manualmente?",
    confirmManualMsg:
      "Usa questa azione quando non ci saranno più ospiti a fare il check-in e devi inviare ora le informazioni finali al responsabile della prenotazione.",
    yesSendNow: "Sì, invia ora",
    cancel: "Annulla",
    manualSendFailed: "Impossibile completare l'invio manuale.",
    sendProcessedTitle: "Invio elaborato",
    finalInfoProcessed: "Le informazioni finali del check-in sono già state elaborate.",
    couldNotSend: "Impossibile inviare",

    confirmResendArrivalTitle: "Reinviare le istruzioni di arrivo?",
    confirmSendArrivalTitle: "Inviare ora le istruzioni di arrivo?",
    confirmResendArrivalMsg:
      "Le istruzioni di arrivo sono già state inviate. Vuoi inviarle di nuovo all'ospite ora?",
    confirmSendArrivalMsg:
      "Le istruzioni di arrivo (messaggio, accessi e file configurati) verranno inviate all'ospite ora, senza attendere l'orario previsto.",
    arrivalSendFailed: "Impossibile inviare le istruzioni di arrivo.",
    pendingDeliveryTitle: "In attesa di consegna",
    instructionsSentTitle: "Istruzioni inviate",
    arrivalSentToGuest: "Le istruzioni di arrivo sono state inviate all'ospite.",

    stepGuestData: "Dati dell'ospite",
    stepSignature: "Firma",
    stepRegistered: "Check-in registrato",

    sectionPersonal: "Dati personali",
    sectionStay: "Soggiorno",
    sectionDocument: "Documento",

    nombre: "Nome",
    apellido: "Cognome",
    sexo: "Sesso",
    select: "Seleziona",
    male: "Maschile",
    female: "Femminile",
    preferNotToSay: "Preferisco non dirlo",
    other: "Altro",
    birthDate: "Data di nascita",
    minorsTraveling: "Viaggiano minori in questa prenotazione?",
    no: "No",
    yes: "Sì",
    relationshipMinor: "Parentela del minore",
    relationshipToMinor: "Parentela rispetto al minore",
    phone: "Telefono",
    email: "E-mail",
    checkInDate: "Data di arrivo",
    checkOutDate: "Data di partenza",

    nationality: "Nazionalità",
    cittadinanza: "Cittadinanza",
    documentType: "Tipo di documento",
    documentNumber: "Numero di documento",
    supportNumber: "Numero di supporto",
    docTypes: {
      passport: "Passaporto",
      identityDoc: "Documento d'identità",
      co_cc: "Carta di cittadinanza",
      co_ce: "Carta di soggiorno per stranieri",
      co_ppt: "Permesso di protezione temporanea",
      co_pep: "Permesso speciale di permanenza",
      co_de: "Documento straniero",
    },
    relationships: {
      co: {
        PADRE: "Padre",
        MADRE: "Madre",
        HIJO: "Figlio/a",
        ABUELO: "Nonno/a",
        HERMANO: "Fratello/Sorella",
        TIO: "Zio/Zia",
        TUTOR: "Tutore legale",
        OTRO: "Altro",
      },
      es: {
        HJ: "Figlio/a",
        AB: "Nonno/a",
        BA: "Bisnonno/a",
        BN: "Pronipote",
        CD: "Cognato/a",
        CY: "Coniuge",
        HR: "Fratello/Sorella",
        NI: "Nipote",
        OT: "Altro",
        PM: "Padre/Madre",
        SB: "Nipote (di zii)",
        SG: "Suocero/a",
        TI: "Zio/Zia",
        TU: "Tutore",
        YN: "Genero/Nuora",
      },
    },

    italyBannerTitle: "Dati richiesti in Italia · Alloggiati Web",
    italyBannerText:
      "La Polizia di Stato richiede lo stato di nascita, il comune di nascita e il luogo di rilascio del documento.",
    sectionBirthData: "Dati di nascita",
    statoNascita: "Stato di nascita",
    birthStateHint: "Lo stato di nascita può essere diverso dalla cittadinanza.",
    comuneNascita: "Comune di nascita",
    luogoRilascio: "Luogo di rilascio del documento",
    luogoRilascioHint: "Comune italiano o Stato estero che ha rilasciato il documento.",
    searchCittadinanza: "Cerca la cittadinanza…",
    searchStatoNascita: "Cerca lo stato di nascita…",
    searchComuneNascita: "Cerca il comune di nascita…",
    searchComuneRilascio: "Comune di rilascio…",
    searchStatoRilascio: "Stato di rilascio…",

    sectionSes: "Dati SES Hospedajes",
    countryResidence: "Paese di residenza",
    cityResidence: "Città di residenza",
    address: "Indirizzo",
    zipCode: "Codice postale",
    paymentMethod: "Metodo di pagamento",
    paymentDate: "Data di pagamento",
    pay: {
      efectivo: "Contanti",
      destino: "Pagamento a destinazione",
      tarjeta: "Carta",
      movil: "Pagamento mobile",
      plataforma: "Piattaforma",
      transferencia: "Bonifico",
    },

    sireLegalTitle: "SIRE & TRA — Avviso legale",
    sireLegalText:
      "Per le strutture in Colombia, le informazioni richieste vengono raccolte in conformità con la normativa di Migración Colombia (SIRE) e il registro degli ospiti (TRA).",
    sectionSire: "Dati SIRE / TRA",
    searchNationality: "Cerca nazionalità...",
    searchCountry: "Cerca paese...",
    noResults: "Nessun risultato",
    countryOrigin: "Paese di provenienza",
    searchCountryOrigin: "Cerca paese di provenienza...",
    cityOrigin: "Città di provenienza",
    searchCity: "Cerca città...",
    searchMunicipality: "Cerca comune...",
    nextDestinationCountry: "Paese di prossima destinazione",
    searchDestinationCountry: "Cerca paese di destinazione...",
    summaryOrigin: "Provenienza",
    summaryDestination: "Destinazione",

    sectionIdentity: "Verifica dell'identità",
    recommended: "consigliato",
    identityActiveInfo:
      "La struttura ha la verifica dell'identità attiva. Carica le foto del documento dell'ospite.",
    documentFront: "Fronte del documento",
    uploadPhoto: "Carica foto",
    selfieGuest: "Selfie dell'ospite",
    altDocumentFront: "Fronte del documento",
    altMinorAuth: "Autorizzazione del minore",
    titleRemove: "Elimina",

    sectionMinorDocs: "Documentazione del minore",
    optional: "facoltativo",
    minorInfo: "Per i minori puoi caricare l'autorizzazione al viaggio o il documento del tutore.",
    guardianAuthDoc: "Autorizzazione / Documento del tutore",
    uploadDocument: "Carica documento",

    sectionSignature: "Firma dell'ospite",
    signatureHint: "Chiedi all'ospite di firmare nel riquadro per accettare le condizioni della struttura.",
    undo: "Annulla",
    clear: "Cancella",
    termsAccept: "L'ospite accetta i termini e le condizioni della struttura",

    successTitle: "Check-in registrato!",
    successBefore: "Il check-in di",
    successAfter: "è stato salvato correttamente.",

    next: "Avanti",
    back: "Indietro",
    saving: "Salvataggio...",
    saveCheckin: "Salva check-in",
    close: "Chiudi",

    vNombre: "Il nome è obbligatorio",
    vApellido: "Il cognome è obbligatorio",
    vSexo: "Il sesso è obbligatorio",
    vBirthDate: "La data di nascita è obbligatoria",
    vPhone: "Il telefono è obbligatorio",
    vCheckIn: "La data di arrivo è obbligatoria",
    vCheckOut: "La data di partenza è obbligatoria",
    vNationality: "La nazionalità è obbligatoria",
    vDocType: "Il tipo di documento è obbligatorio",
    vDocNumber: "Il numero di documento è obbligatorio",
    vEmailFormat: "L'e-mail non ha un formato valido",
    vDocSupport: "Il numero di supporto del documento è obbligatorio",
    vMinors: "Indica se viaggiano minori nella prenotazione",
    vRelationship: "La parentela del minore accompagnato è obbligatoria",
    vCountryResidence: "Il paese di residenza è obbligatorio",
    vCityResidence: "La città di residenza è obbligatoria",
    vAddress: "L'indirizzo è obbligatorio",
    vZip: "Il codice postale è obbligatorio",
    vPaymentMethod: "Il metodo di pagamento è obbligatorio",
    vPaymentDate: "La data di pagamento è obbligatoria",
    vCountryOrigin: "Il paese di provenienza è obbligatorio",
    vNextDest: "Il paese di prossima destinazione è obbligatorio",
    vCityOrigin: "La città di provenienza è obbligatoria",
    vStatoNascita: "Lo stato di nascita (Stato di nascita) è obbligatorio",
    vComuneNascita: "Il comune di nascita (Comune di nascita) è obbligatorio",
    vLuogoRilascio: "Il luogo di rilascio del documento (Luogo di rilascio) è obbligatorio",

    vTerms: "Devi accettare i termini per continuare",
    vSignaturePad: "Errore nell'accesso al pannello della firma",
    vSignature: "La firma è obbligatoria",
    saveCheckinError: "Si è verificato un errore durante il salvataggio del check-in",
    saveCheckinErrorGeneric: "Errore durante il salvataggio del check-in",
    socketCheckinDone: "<strong>{name}</strong> ha completato il check-in manuale",
    identityPhotosError: "Il check-in è stato salvato, ma non è stato possibile caricare le foto d'identità",
    minorAuthError: "Il check-in è stato salvato, ma non è stato possibile caricare l'autorizzazione del minore",

    docDni: "DNI non valido. Deve avere 8 cifre seguite dalla lettera di controllo corretta (es: 12345678Z)",
    docNie: "NIE non valido. Formato: X/Y/Z + 7 cifre + lettera di controllo (es: X1234567Z)",
    docPassport: "Passaporto non valido. Deve avere tra 6 e 20 caratteri alfanumerici",
    docCc: "Carta di cittadinanza non valida. Deve avere tra 6 e 10 cifre",
    docCe: "Carta di soggiorno per stranieri non valida. Deve avere tra 6 e 12 caratteri alfanumerici",
    docPptPep: "{tipo} non valido. Deve avere tra 4 e 15 caratteri alfanumerici",

    zipNotFound: "Codice postale non trovato. Verifica il numero e riprova.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    requestPendingTitle: "Richiesta di prenotazione in sospeso",
    requestPendingText:
      "L'ospite ha richiesto queste date. Il calendario non è bloccato finché non approvi.",
    approving: "Approvazione…",
    approve: "Approva",
    rejecting: "Rifiuto…",
    reject: "Rifiuta",
    requestRejectedTitle: "Richiesta rifiutata",
    requestRejectedText: "Questa richiesta è stata rifiutata dalla struttura e non può più essere confermata.",
    awaitingPaymentTitle: "In attesa del pagamento dell'ospite",
    awaitingPaymentText:
      "Il calendario è bloccato temporaneamente. In assenza di pagamento, la disponibilità viene liberata automaticamente.",
    remaining: "rimanente",
    marking: "Contrassegno...",
    markAsPaid: "Segna come pagata",
    expiring: "Scadenza...",
    markAsExpired: "Segna come scaduta",

    extensionPendingTitle: "Proroga del soggiorno in sospeso",
    extraNights: "{count} notte/i extra",
    newCheckout: "nuova partenza",
    awaitingGuestPayment: "in attesa del pagamento dell'ospite",
    holdLeftMinutes: "restano {min} min per pagare",
    holdLeftSeconds: "restano {seg} s per pagare",
    holdExpired: "il termine è scaduto: le notti sono state liberate",
    pendingApproval: "in attesa di approvazione",
    confirming: "Conferma...",

    observation: "Nota",

    pendingCharge: "in attesa di incasso",
    processing: "Elaborazione...",

    clientRequested: "Il cliente ha richiesto:",
    serviceFallback: "Servizio",
    toConsult: "su richiesta",

    approveRequestTitle: "Approva richiesta",
    amountToCharge: "Importo da addebitare",
    noCharge: "0 = senza addebito",
    approveHint:
      "Se hai un gateway collegato, all'ospite viene inviato un <strong>link di pagamento</strong> (WhatsApp + e-mail). In caso contrario, gli viene indicato che <strong>pagherà all'arrivo</strong>.",
    cancel: "Annulla",
    close: "Chiudi",
    approveAndNotify: "Approva e avvisa",

    reservationTotal: "Totale della prenotazione:",
    onRequestPaidSeparately: `gli elementi "su richiesta" si pagano a parte`,
    fullPayment: "Pagamento totale",
    noBalance: "(senza saldo)",
    deposit: "Acconto",
    balance: "saldo",
    markPaidHint: `L'importo scelto viene registrato come incassato. Il "totale" copre soggiorno, pulizia e servizi a pagamento (es. Uber); gli elementi "su richiesta" hanno il proprio incasso.`,
    confirm: "Conferma",

    paymentExpiredTitle: "Tempo di pagamento scaduto",
    paymentExpiredText: "La prenotazione temporanea è scaduta e la disponibilità è stata liberata automaticamente.",

    overbookingTitle: "Prenotazione in overbooking",
    overbookingText:
      "Le sue date sono in conflitto con un'altra prenotazione di questa struttura. Le date restano bloccate sulle OTA. Se hai già risolto il conflitto (annullato o spostato l'altra prenotazione), confermala qui.",
    verifying: "Verifica...",
    confirmReservation: "Conferma prenotazione",

    checkinInvitation: "Invito al check-in",
    copyCheckinLink: "Copia link di check-in",
    editReservation: "Modifica prenotazione",

    codesAndAccess: "Codici e accessi",
    codesAndAccessSub: "Chiavi e link di accesso dell'ospite",
    currentAccessCodes: "Codici di accesso attuali:",
    currentAccessCode: "Codice di accesso attuale:",
    guestDigitalAccess: "Accesso digitale dell'ospite",
    copyOpenLink: "Copia link di apertura",
    copy: "Copia",
    openLink: "Apri link di apertura",
    open: "Apri",
    yacanNote: "L'accesso di questa prenotazione è gestito da <b>YACAN</b> automaticamente con le sue serrature.",
    digitalKeyEkey: "Chiave digitale (ekey)",
    openDigitalKey: "Apri chiave digitale",
    previousCodesExpired: "Codici precedenti (già scaduti):",
    sentOn: "inviato il",
    generated: "generato",
    expiredOn: "scaduto il",

    amountAndPayment: "Importo e pagamento",
    amountAndPaymentSub: "Dettaglio, stato dell'incasso e fatturazione",

    guestJourney: "Percorso dell'ospite",
    eventsCount: "{count} evento | {count} eventi",
    journeySubtitle: "Tracciabilità completa dalla prenotazione alla partenza",
    stagesCompleted: "fasi completate",
    nextLabel: "Prossima:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "Cosa manca",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Schedina alloggiati",
    authoritiesAction: "è stato comunicato alle autorità",
    authoritiesDesc: "Inviato a {services}",
    viewInChat: "Vedi nella chat",

    accessCode: "Codice di accesso",
    accessCodeSub: "Modifica e invia la chiave all'ospite",
    currentlyConfiguredCode: "Codice attualmente configurato",
    newCode: "Nuovo codice",
    keepSameToResend: "lascialo invariato per reinviare senza modifiche",
    placeholderCode: "Es: ABCD1234",
    codeSavedUppercaseHint: "Il codice verrà salvato in maiuscolo e inviato tramite WhatsApp e/o e-mail.",
    sending: "Invio in corso...",
    saveAndSendToGuest: "Salva e invia all'ospite",

    resendAccess: "Reinvia accesso",
    sendAccess: "Invia accesso",
    resendPin: "Reinvia PIN",
    sendPin: "Invia PIN",
    activating: "Attivazione...",
    resendCode: "Reinvia codice",
    sendAccessCode: "Invia codice di accesso",

    channelManager: "channel manager",
    directBooking: "prenotazione diretta",
    directTag: "Diretta",
    bookingRegistered: "Prenotazione registrata",
    bookedViaOta: "ha prenotato tramite OTA",
    createdBooking: "ha creato la prenotazione",
    incomingVia: "In entrata tramite {channel}",
    confirmedTag: "Confermata",
    pendingTag: "In sospeso",
    bookingConfirmed: "Prenotazione confermata",
    pendingConfirmation: "In attesa di conferma",
    receivedConfirmation: "ha ricevuto la conferma della prenotazione",
    awaitingConfirmationAction: "è in attesa di conferma",
    propertyConfirmed: "La struttura ha confermato la prenotazione",
    awaitingConfirmationDesc: "In attesa di conferma",
    sentTag: "Inviata",
    notSentTag: "Non inviata",
    checkinInvitationTitle: "Invito al check-in",
    receivedCheckinInvite: "ha ricevuto l'invito al check-in",
    notReceivedCheckinInvite: "non ha ancora ricevuto l'invito al check-in",
    checkinLinkSent: "Link di check-in inviato all'ospite",
    inviteNotSentYet: "L'invito non è ancora stato inviato",
    completedTag: "Completato",
    checkinOnline: "Check-in online",
    didCheckinOnline: "ha effettuato il check-in online",
    notYetCheckinOnline: "non ha ancora effettuato il check-in online",
    guestsRegistered: "{count} ospite/i registrato/i",
    guestNotCompletedCheckin: "L'ospite non ha ancora completato il check-in",
    sentTagPlural: "Inviati",
    accessCodes: "Codici di accesso",
    receivedAccessCodes: "ha ricevuto i codici di accesso",
    notReceivedAccessCodes: "non ha ancora ricevuto i codici di accesso",
    accessKeysSent: "Chiavi di accesso inviate all'ospite",
    pendingSendAccess: "In attesa dell'invio degli accessi",
    finishedTag: "Terminata",
    plannedTag: "Previsto",
    guestCheckout: "Partenza dell'ospite",
    finishedStay: "ha terminato il soggiorno",
    plannedCheckout: "ha la partenza prevista",
    stayFinished: "Il soggiorno è terminato",
    autoCheckoutScheduled: "Check-out automatico programmato",
    theGuest: "L'ospite",
    theTeam: "Il team",
    theChannel: "Il canale",
    theSystem: "Il sistema",
    calledFromNumber: "ha chiamato dal numero {phone}",

    filterAll: "Tutto",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Chiamate",
    filterCheckin: "Check-in",
    filterAccess: "Accesso",
    filterBooking: "Prenotazione",

    error: "Errore",
    requestApprovedMsg: "Richiesta approvata. La prenotazione è confermata.",
    requestApprovedTitle: "✓ Approvata",
    couldNotApprove: "Impossibile approvare.",
    confirmRejectRequestMsg: "Sei sicuro di voler rifiutare questa richiesta? L'operazione non può essere annullata.",
    rejectRequestHeader: "Rifiuta richiesta",
    yesReject: "Sì, rifiuta",
    requestRejectedMsg: "Richiesta rifiutata.",
    rejectedTitle: "Rifiutata",
    couldNotReject: "Impossibile rifiutare.",
    couldNotLoadOptions: "Impossibile caricare le opzioni; verrà contrassegnato il totale.",
    noticeTitle: "Avviso",
    depositMarkedPaid: "Acconto contrassegnato come pagato. Prenotazione confermata con saldo in sospeso.",
    fullMarkedPaid: "Prenotazione contrassegnata come pagata per intero e confermata.",
    paymentConfirmedTitle: "Pagamento confermato",
    couldNotMarkPaid: "Impossibile segnare come pagata.",
    tempReservationExpired: "La prenotazione temporanea è stata fatta scadere e ha liberato la disponibilità.",
    reservationExpiredTitle: "Prenotazione scaduta",
    couldNotMarkExpired: "Impossibile segnare come scaduta.",
    extensionMarkedPaid: "La proroga è stata contrassegnata come pagata e confermata.",
    extensionConfirmedTitle: "Proroga confermata",
    couldNotConfirmExtension: "Impossibile confermare la proroga.",
    extensionCancelled: "La proroga è stata annullata e la disponibilità è stata liberata.",
    extensionRejectedTitle: "Proroga rifiutata",
    couldNotRejectExtension: "Impossibile rifiutare la proroga.",
    chargeMarkedPaid: "L'addebito è stato contrassegnato come pagato.",
    chargeRegisteredTitle: "Incasso registrato",
    couldNotMarkChargePaid: "Impossibile segnare l'addebito come pagato.",
    chargeRejected: "L'addebito è stato rifiutato e rimosso dalla prenotazione.",
    chargeRejectedTitle: "Addebito rifiutato",
    couldNotRejectCharge: "Impossibile rifiutare l'addebito.",
    approvedState: "Approvato",
    rejectedState: "Rifiutato",
    paidState: "Pagato",
    pendingYourResponse: "In attesa della tua risposta",
    enterValidAmount: "Indica un importo valido (0 = senza addebito).",
    amountTitle: "Importo",
    approvedPaymentLinkSent: "Approvata. Il link di pagamento è stato inviato all'ospite (WhatsApp + e-mail).",
    serviceApprovedTitle: "Servizio approvato",
    approvedPayOnArrival: "Approvata. L'ospite pagherà all'arrivo (nessun gateway collegato).",
    approvedGuestNotified: "Approvata. L'ospite è stato avvisato.",
    couldNotApproveRequest: "Impossibile approvare la richiesta.",
    requestRejectedNotified: "Richiesta rifiutata. L'ospite è stato avvisato.",
    serviceRejectedTitle: "Servizio rifiutato",
    couldNotRejectRequest: "Impossibile rifiutare la richiesta.",
    resendAccessLinkMsg: "Vuoi reinviare il link di accesso tramite i canali disponibili?",
    sendAccessLinkMsg: "Vuoi inviare il link di accesso tramite i canali disponibili?",
    resendPinMsg:
      "Vuoi reinviare il codice di accesso tramite i canali disponibili? Verrà generato un nuovo PIN.",
    sendPinMsg: "Vuoi generare e inviare il codice di accesso tramite i canali disponibili?",
    sendDigitalAccessHeader: "Invia accesso digitale",
    sendPinHeader: "Invia PIN di accesso",
    send: "Invia",
    accessLinkSent: "Link di accesso inviato all'ospite",
    accessSentTitle: "Accesso inviato",
    successSummary: "Successo",
    digitalAccessSentDetail: "L'accesso digitale è stato inviato per {count} dispositivo/i",
    ttlockCodesGenerated: "{count} codici TTLock sono stati generati ed elaborati per la prenotazione.",
    accessCodeResent: "Codice di accesso reinviato: {code}",
    accessCodeGeneratedSent: "Codice di accesso generato e inviato: {code}",
    pinSentTitle: "PIN inviato",
    pinProcessedDetail: "Il PIN è stato elaborato per {count} serratura/e",
    pinProcessedBlebox: "e {count} porta/e elettronica/che",
    couldNotSendAccessCode: "Impossibile inviare il codice di accesso",
    codeCopied: "Codice copiato negli appunti",
    mainGate: "Cancello principale",
    accommodation: "Struttura",
    doorLabel: "Porta della struttura",
    validUntil: "Valido fino al: {date}",
    earlyAccessLinkMsg:
      "Questo attiverà il link di accesso immediatamente (prima dell'orario normale di check-in).",
    earlyAccessPinMsg: "Questo attiverà il PIN immediatamente (prima dell'orario normale di check-in).",
    earlyAccessHeader: "Accesso anticipato",
    activate: "Attiva",
    earlyAccessActivated: "Accesso anticipato attivato",
    okSummary: "OK",
    earlyAccessActivatedDetail: "L'accesso anticipato è stato attivato",
    couldNotActivateEarlyAccess: "Impossibile attivare l'accesso anticipato",
    cancelReservationMsg:
      "La prenotazione verrà annullata completamente. Se occupa più camere (anche di tipi diversi), verranno tutte annullate e liberate. Questa azione non può essere annullata.",
    goBack: "Torna indietro",
    resolveOverbookingMsg:
      "Verrà verificato che non ci sia più conflitto con un'altra prenotazione. Se è libera, la prenotazione passerà a confermata e le sue date resteranno bloccate sulle OTA.",
    confirmOverbookingHeader: "Conferma prenotazione in overbooking",
    reservationConfirmed: "Prenotazione confermata.",
    couldNotConfirmReservation: "Impossibile confermare la prenotazione.",
    reservationCancelledFreed: "Prenotazione annullata. {count} camere sono state liberate.",
    otaLangPrompt:
      "Questa prenotazione OTA non ha un telefono. Indica la lingua del messaggio per inviare il check-in tramite la chat dell'OTA: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Invito elaborato. Inviato anche via e-mail e chat OTA.",
    inviteProcessedOta: "Invito elaborato. Inviato anche via chat OTA.",
    inviteProcessedEmail: "Invito elaborato. Inviato anche via e-mail.",
    couldNotSendCheckinInvite: "Impossibile inviare l'invito al check-in",
    couldNotLoadConversations: "Impossibile caricare le conversazioni",
    reservationUpdatedShort: "Prenotazione aggiornata",
    couldNotUpdateReservation: "Impossibile aggiornare la prenotazione",
    codeEmpty: "Il codice non può essere vuoto",
    attentionTitle: "Attenzione",
    accessCodeProcessed: "Codice di accesso elaborato correttamente",
    sentCheckTitle: "Inviato ✓",
    accessCodeSendProcessed: "L'invio del codice di accesso è stato elaborato.",
    couldNotSendCode: "Impossibile inviare il codice",
    chatOta: "chat OTA",
    emailChannel: "e-mail",
    channelsUsed: "Canali utilizzati: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "Questo numero non sembra valido per {pais}. Se l'ospite è di un altro paese, cambia la bandiera. Premi di nuovo salva per tenerlo comunque.",
  },
  hotelResModal: {
    otaBanner:
      "Prenotazione OTA: non puoi modificare <strong>date</strong>, <strong>tipo</strong> né <strong>quantità di camere</strong> da WA Checkin. Devi farlo dall'OTA (Booking, Airbnb, ecc.).",
    otaLock: "Prenotazione OTA: date, tipo e quantità possono essere modificati solo dall'OTA.",
    close: "Chiudi",
    placeholderEmail: "email@esempio.com",
    roomAbbr: "Cam.",
    fromCalendar: "dal calendario",
    noMatches: "Nessuna corrispondenza",
    undo: "Ripristina",
    removeRoom: "Rimuovi camera",
    willBeRemovedOnSave: "Verrà rimossa al salvataggio delle modifiche.",
    checkingAvailability: "Verifica della disponibilità…",
    availableCount: "{count} disponibile | {count} disponibili",
    notEnoughAvail: "Disponibilità insufficiente",
    freeCount: "{count} libera | {count} libere",
    total: "totale",
    nightsCount: "{count} notte | {count} notti",
    resendConfirmationTitle: "Reinvia il messaggio di conferma",
    resendConfirmationSub: "Invia di nuovo il modello di conferma all'ospite.",
    resendConfirmationNote:
      "Modificando la prenotazione, il <strong>modello di conferma</strong> di questa prenotazione verrà reinviato.",
    room: "Camera",

    noEnoughUnitsFree: "Disponibilità insufficiente. Unità libere: {units}.",
    closedPeriodManual: "Le date includono giorni chiusi dal proprietario.",
    noAvailForDates: "Nessuna disponibilità per queste date.",
    selectRoomType: "Seleziona un tipo di camera.",
    selectValidDates: "Seleziona date valide.",
    enterGuestName: "Indica il nome dell'ospite.",
    invalidEmail: "L'e-mail non è valida.",
    enterValidPhone: "Indica un telefono valido.",
    noAvailCreateModify: "Nessuna disponibilità per creare/modificare con queste date.",
    aRoom: "una camera",
    notEnoughAvailIn: "Disponibilità insufficiente in: {names}.",
    missingOnCreate: "onCreateReservation mancante nel componente padre.",
    aRoomType: "un tipo di camera",
    notEnoughAvailInType: `Disponibilità insufficiente in "{name}".`,
    sameHotelOnly: "Una prenotazione non può mescolare camere di due hotel. Togli quelle che non sono di questo hotel.",
    otherHotelLinesDropped: "Le camere dell’hotel precedente sono state rimosse: una prenotazione è di un solo hotel.",
    partiallyCreated: "Sono state create {ok} camere su {total} e la successiva è fallita. Controlla la prenotazione prima di riprovare.",
    reservationIdNotFound: "ID della prenotazione non trovato.",
    cannotRemoveAll: "Non puoi rimuovere tutte le camere. Per farlo, annulla l'intera prenotazione.",
    thisRoom: "questa camera",
    confirmRemoval:
      "Stai per RIMUOVERE dalla prenotazione: {names}. Queste camere vengono liberate e non vengono più fatturate. Continuare e salvare?",
    couldNotAdd: "Non è stato possibile aggiungere {name}.",
    couldNotUpdate: `Impossibile aggiornare "{name}".`,
    couldNotRemove: `Impossibile rimuovere "{name}".`,
    couldNotRemovePrimary: "Impossibile rimuovere la camera principale.",
    reservationUpdated: "Prenotazione aggiornata con successo",
    updatedPartially: "È stata salvata solo una parte: controlla le camere della prenotazione.",
    couldNotUpdateReservation: "Impossibile aggiornare la prenotazione.",
  },
};
